import React, { useState, useRef, useEffect } from "react";
import { dynamicSort } from "helpers/hooks";
import styles from "css_modules/Select.module.css";
import clsx from "clsx";
import {ReactComponent as Chevron} from 'assets/svg/2_chevron_down.svg';
export const Select = ({
  blank,
  field,
  form,
  firstOption,
  displayAttribute,
  inputClass = "",
  notNull,
  noBlankOption = false,
  emptyOption = false,
  onlyvalid,
  data = [],
  dropUp = false,
  value: externalValue,
  onChange,
  withBorder,
  accountingYear,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const containerRef = useRef(null);

  let currentValue=undefined
  
  
  if (accountingYear && !externalValue && externalValue!==""){
    currentValue = accountingYear.id
  }
  else{
    currentValue =externalValue?.id?externalValue.id:externalValue
  }
  

  const emitChange = (val) => {
    const event = {
      target: {
        name: field?.name,
        value: val
      }
    };

    if (field?.onChange) {
      field.onChange(event);
    }

    if (onChange) {
      onChange(event);
    }

    if (form?.setFieldValue && field?.name) {
      form.setFieldValue(field.name, val);
    }
  };

  const preSelectFirst = (field) => {
    const regex = RegExp("^costs\\W\\d+\\Wcurrency");
    if (regex.test(field?.name)) return true;
    if (field?.name === "info.accounting_year") return true;
    return false;
  };

  if (field?.name === "costs.0.tax_rate" && data?.length) {
    data.sort(dynamicSort("-rate"));
    if (form?.values?.costs?.[0]?.tax_rate === "") {
      setTimeout(() => emitChange(data[0]?.id));
    }
  }

  if (field?.name === "info.accounting_year" && data?.length) {
    data.sort(dynamicSort("-year"));
    if (form?.values?.info?.accounting_year === "") {
      setTimeout(() => emitChange(data[0]?.id));
    }
  }

  const options = [];

  if (!preSelectFirst(field)) {
    if (emptyOption) options.push({ id: -2, label: "" });

    if (!onlyvalid && !props.customdivider && !notNull && !noBlankOption) {
      options.push({ id: "", label: firstOption || "---" });
    }

    if (!onlyvalid && !props.customdivider && noBlankOption) {
      options.push({ id: -1, label: firstOption || "---" });
    }
  }

  data?.forEach(item => {
    const id = item?.id ?? item?.slug ?? item;
    const label =
      typeof item === "string"
        ? item
        : item?.[displayAttribute || "title"] ?? blank;

    options.push({
      id,
      label,
      disabled: item?.off === "true"
    });
  });

  const selectedOption = options.find(
    o => String(o.id) === String(currentValue)
  );
  
  
  const selectValue = (opt) => {
    if (!opt || opt.disabled) return;
    setIsOpen(false);
    emitChange(opt.id);
  };
  
  const handleKeyDown = (e) => {
    if (!isOpen) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsOpen(true);
        setHighlightedIndex(
          dropUp ? options.length - 1 : 0
        );
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(i =>
        dropUp
          ? Math.max(i - 1, 0)
          : Math.min(i + 1, options.length - 1)
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(i =>
        dropUp
          ? Math.min(i + 1, options.length - 1)
          : Math.max(i - 1, 0)
      );
    }

    if (e.key === "Enter" && highlightedIndex >= 0) {
      selectValue(options[highlightedIndex]);
    }

    if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div
      ref={containerRef}
       className={clsx(
        styles.selectContainer,
        withBorder && styles.withBorder,
        inputClass
      )}
      tabIndex={0}
      role="combobox"
      aria-expanded={isOpen}
      aria-controls="select-listbox"
      aria-haspopup="listbox"
      onClick={() => setIsOpen(o => !o)}
      onKeyDown={handleKeyDown}
    >

      <div className={styles.selectedValue}>
        {selectedOption?.label ?? blank ?? "---"}
      </div>

      <span className={`${styles.arrow} ${isOpen ? styles.open : ""}`}>
          <Chevron />
      </span>

      <div
        className={`${styles.options} ${isOpen ? styles.open : ""} ${
          dropUp ? styles.dropup : ""
        }`}
      >
        {options.map((opt, idx) => (
          <div
            key={`${opt.id}-${idx}`}
            className={`${styles.option}
              ${idx === highlightedIndex ? styles.highlighted : ""}
              ${String(opt.id) === String(currentValue) ? styles.selected : ""}
              ${opt.disabled ? styles.disabled : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              selectValue(opt);
            }}
            onMouseEnter={() => setHighlightedIndex(idx)}
          >
            {opt.label}
          </div>
        ))}
      </div>
    </div>
  );
};
